enum EmployeeStatusFilter {
  All = 'All',
  Active = 'Active',
  InActive = 'Inactive'
}

export default EmployeeStatusFilter;
